export default {
  env: 'production',
  website: 'hooshmandteb.ir',
  apiServer: 'api.hooshmandteb.ir',
  staticServer: 'static.hooshmandteb.ir',
  aiEndpoint: 'https://ai.hooshmandteb.ir/api/endpoint/',
  ssl: true
}
